import {Component, OnInit} from '@angular/core';
import {AuthServerProvider} from '../common.module/auth/auth-jwt.service';
import {JwtHelperService} from '@auth0/angular-jwt';
import {ToastService} from 'ng-uikit-pro-standard';
import {isNullOrUndefined} from 'util';
import {Router} from '@angular/router';
import { EventBusService } from '../common.module/util/event-bus.service';
import { UserAuth } from '../common.module/auth/user-auth.model';

@Component({
  selector: 'app-main-admin',
  templateUrl: './main.component.html'
})
export class MainAdminComponent implements OnInit {
  public validWin = false;
  private userDecode : UserAuth;
  constructor(private auth: AuthServerProvider,
              private toast: ToastService,
              private router: Router,
              private eb: EventBusService) {
  }

  ngOnInit() {
    const helper = new JwtHelperService();
    this.userDecode = helper.decodeToken(this.auth.getToken());
    console.log('Usuario iniciado');
    // if (this.route.url)
    if (isNullOrUndefined(this.userDecode)) {
      setTimeout(() => {
        this.toast.error('No se ha iniciado sesión');
          this.router.navigate(['login']);
      }, 50);
    }else {
      this.cargarNotificaciones();
    }
  }

  cargarNotificaciones(){
      if(this.userDecode)
      {
        this.eb.registerHandler('ms.notifications.user.'+ this.userDecode._id, (error, message )=>{
          if (error) {
            console.error('AppEventBusService.handleAction error', error);
            return;
          }
          if (!message.body) {
            console.error('AppEventBusService.handleAction - body is required in message', message);
            return;
          }
          if(message.body.tipo == "success")
            this.toast.success(message.body.detalle);
          else if(message.body.tipo == "warning")
            this.toast.warning(message.body.detalle);
          else if(message.body.tipo == "info")
            this.toast.info(message.body.detalle);
          else if(message.body.tipo == "error")
            this.toast.error(message.body.detalle);
          else if(message.body.tipo == "info")
            this.toast.info(message.body.detalle);
        });
      }
  }
}

